<template>
  <a-modal
    :visible="visible"
    @ok="confirmar"
    :confirmLoading="modalLoading"
    @cancel="cancelar"
    style="top: 10px; max-width: 900px;"
    width="95%">
    <template slot="title">
      <g-wiki keyValue="WIKI_DIR_ESTRUCTURADA"/>
      Actualización de datos
    </template>
    <a-form :form="form" @submit="confirmar" :layout="'vertical'">
      <a-row :gutter="16">
        <a-col :xs="24" :sm="5">
          <g-select :options="listas.via_principal"
                    :decorator="['via_principal']"
                    :formItemConfig="{ label:'Vía Principal', ...fiOptions}"></g-select>
        </a-col>
        <a-col :xs="24" :sm="5">
          <a-form-item label="Número o Nombre" v-bind="fiOptions">
            <a-input v-decorator="['via_principal_numero_o_nombre']">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="5">
          <g-select :options="listas.letra"
                    :decorator="['via_principal_letra']"
                    :formItemConfig="{ label:'Letra', ...fiOptions}"></g-select>
        </a-col>
        <a-col :xs="24" :sm="5">
          <g-select :options="listas.otros"
                    :decorator="['via_principal_otros']"
                    :formItemConfig="{ label:'...', ...fiOptions}"></g-select>
        </a-col>
        <a-col :xs="24" :sm="4">
          <g-select :options="listas.puntos_cardinales"
                    :decorator="['via_principal_punto_cardinal']"
                    :formItemConfig="{ label:'Punto Cardinal', ...fiOptions}"></g-select>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :xs="24" :sm="10">
          <g-select :options="listas.via_principal"
                    :decorator="['via_secundaria']"
                    :formItemConfig="{ label:'Vía Secundaria', ...fiOptions}"></g-select>
        </a-col>
        <a-col :xs="24" :sm="5">
          <a-form-item label="No. Vía" v-bind="fiOptions">
            <a-input v-decorator="['via_secundaria_numero_o_nombre']">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="5">
          <g-select :options="listas.letra"
                    :decorator="['via_secundaria_letra']"
                    :formItemConfig="{ label:'Letra', ...fiOptions}"></g-select>
        </a-col>
        <a-col :xs="24" :sm="4">
          <a-form-item label="Número placa" v-bind="fiOptions">
            <a-input v-decorator="['numero_inmueble']">
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :xs="24" :sm="15">
          <g-select :options="listas.comp1"
                    :decorator="['comp1']"
                    :formItemConfig="{ label:'Complemento 1', ...fiOptions}"></g-select>
        </a-col>
        <a-col :xs="24" :sm="9">
          <a-form-item label="Número Comp1" v-bind="fiOptions">
            <a-input v-decorator="['comp1_num']">
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :xs="24" :sm="15">
          <g-select :options="listas.comp2"
                    :decorator="['comp2']"
                    :formItemConfig="{ label:'Complemento 2', ...fiOptions}"></g-select>
        </a-col>
        <a-col :xs="24" :sm="9">
          <a-form-item label="Número Comp2" v-bind="fiOptions">
            <a-input v-decorator="['comp2_num']">
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :xs="24" :sm="15">
          <g-select :options="listas.comp3"
                    :decorator="['comp3']"
                    :formItemConfig="{ label:'Complemento 3', ...fiOptions}"></g-select>
        </a-col>
        <a-col :xs="24" :sm="9">
          <a-form-item label="Número Comp3" v-bind="fiOptions">
            <a-input v-decorator="['comp3_num']">
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col>
          <a-form-item label="Dirección resultante" v-bind="fiOptions">
            <a-input v-model="direccion" :disabled="true">
            </a-input>
          </a-form-item>
        </a-col>
        <a-col>
          <a-form-item label="Dirección actual" v-bind="fiOptions">
            <a-input v-model="direccionActual" :disabled="true">
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>
<script>
  import JSUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        direccion: '',
        modalLoading: false,
        form: this.$form.createForm(this, {
          name: 'direccion',
          onFieldsChange: (_, changedFields) => {
            this.calcularDireccion(changedFields)
          }
        }),
        fiOptions: {
          'label-col': {},
          'wrapper-col': {},
          'has-feedback': true
        },
        listas: {
          via_principal: [
            {value: 'AE', text: 'APARTADO AEREO'},
            {value: 'AU', text: 'AUTOPISTA'},
            {value: 'AV', text: 'AVENIDA'},
            {value: 'AC', text: 'AVENIDA CALLE'},
            {value: 'AK', text: 'AVENIDA CARRERA'},
            {value: 'CL', text: 'CALLE'},
            {value: 'CA', text: 'EJON">CALLEJON'},
            {value: 'CR', text: 'CARRERA'},
            {value: 'CT', text: 'CARRETERA'},
            {value: 'CQ', text: 'CIRCULAR'},
            {value: 'CV', text: 'CIRCUNVALAR'},
            {value: 'DG', text: 'DIAGONAL'},
            {value: 'KM', text: 'KILOMETRO'},
            {value: 'TV', text: 'TRANSVERSAL'},
            {value: 'TC', text: 'TRONCAL'},
            {value: 'VT', text: 'VARIANTE'}],
          letra: [
            {value: 'A', text: 'A'},
            {value: 'B', text: 'B'},
            {value: 'C', text: 'C'},
            {value: 'D', text: 'D'},
            {value: 'E', text: 'E'},
            {value: 'F', text: 'F'},
            {value: 'G', text: 'G'},
            {value: 'H', text: 'H'},
            {value: 'I', text: 'I'},
            {value: 'J', text: 'J'},
            {value: 'K', text: 'K'},
            {value: 'L', text: 'L'},
            {value: 'M', text: 'M'},
            {value: 'N', text: 'N'},
            {value: 'O', text: 'O'},
            {value: 'P', text: 'P'},
            {value: 'Q', text: 'Q'},
            {value: 'R', text: 'R'},
            {value: 'S', text: 'S'},
            {value: 'T', text: 'T'},
            {value: 'U', text: 'U'},
            {value: 'V', text: 'V'},
            {value: 'W', text: 'W'},
            {value: 'X', text: 'X'},
            {value: 'Y', text: 'Y'},
            {value: 'Z', text: 'Z'},
            {value: 'AB', text: 'AB'}
          ],
          otros: [{value: 'BIS', text: 'BIS'}],
          puntos_cardinales: [
            {value: 'ESTE', text: 'ESTE'},
            {value: 'OESTE', text: 'OESTE'},
            {value: 'NES', text: 'NORESTE'},
            {value: 'NOC', text: 'NOROCCIDENTE'},
            {value: 'NRI', text: 'NORORIENTE'},
            {value: 'NORTE', text: 'NORTE'},
            {value: 'OCC', text: 'OCCIDENTE'},
            {value: 'ORI', text: 'ORIENTE'},
            {value: 'SUR', text: 'SUR'},
            {value: 'SES', text: 'SURESTE'},
            {value: 'SOC', text: 'SUROCCIDENTE'},
            {value: 'SOR', text: 'SURORIENTE'}
          ],
          comp1: [{value: 'BQ', text: 'BLOQUE'},
            {value: 'CORREGIMIENTO', text: 'CORREGIMIENTO'},
            {value: 'ET', text: 'ETAPA'},
            {value: 'IN', text: 'INTERIOR'},
            {value: 'MZ', text: 'MANZANA'},
            {value: 'MN', text: 'MEZZANINE'},
            {value: 'SC', text: 'SECTOR'},
            {value: 'SM', text: 'SUPER MANZANA'},
            {value: 'TO', text: 'TORRE'},
            {value: 'VEREDA', text: 'VEREDA'},
            {value: 'VI', text: 'VIA'},
            {value: 'ZN', text: 'ZONA'}],
          comp2: [{value: 'AL', text: 'ALTILLO'},
            {value: 'AP', text: 'APARTAMENTO'},
            {value: 'BG', text: 'BODEGA'},
            {value: 'CS', text: 'CASA'},
            {value: 'CU', text: 'CÉLULA'},
            {value: 'COMUNA', text: 'COMUNA'},
            {value: 'CN', text: 'CONSULTORIO'},
            {value: 'DP', text: 'DEPÓSITO'},
            {value: 'EN', text: 'ENTRADA'},
            {value: 'GA', text: 'GARAJE'},
            {value: 'LC', text: 'LOCAL'},
            {value: 'LT', text: 'LOTE'},
            {value: 'OF', text: 'OFICINA'},
            {value: 'PI', text: 'PISO'},
            {value: 'SO', text: 'SÓTANO'},
            {value: 'TZ', text: 'TERRAZA'},
            {value: 'VEREDA', text: 'VEREDA'}],
          comp3: [{value: 'AG', text: 'AGRUPACIÓN'},
            {value: 'CD', text: 'CIUDADELA'},
            {value: 'CM', text: 'CONDOMINIO'},
            {value: 'CO', text: 'CONJUNTO RESIDENCIAL'},
            {value: 'ED', text: 'EDIFICIO'},
            {value: 'EQ', text: 'ESQUINA'},
            {value: 'ES', text: 'ESTACIÓN'},
            {value: 'FI', text: 'FINCA'},
            {value: 'PQ', text: 'PARQUE'},
            {value: 'UP', text: 'UNIDAD DE POLICIA'},
            {value: 'UL', text: 'UNIDAD RESIDENCIAL'},
            {value: 'UR', text: 'URBANIZACIÓN'}]
        }
      }
    },
    props: ['value', 'visible', 'direccionActual'],
    methods: {
      confirmar (e) {
        e && e.preventDefault()
        this.form.validateFields((err, values) => {
          if (this.$isEmpty(values.comp1) && this.$isEmpty(values.comp1_num) &&
            this.$isEmpty(values.comp2) && this.$isEmpty(values.comp2_num) &&
            this.$isEmpty(values.comp3) && this.$isEmpty(values.comp3_num) &&
            this.$isEmpty(values.numero_inmueble) && this.$isEmpty(values.via_principal) &&
            this.$isEmpty(values.via_principal_letra) && this.$isEmpty(values.via_principal_numero_o_nombre) &&
            this.$isEmpty(values.via_principal_otros) && this.$isEmpty(values.via_principal_punto_cardinal) &&
            this.$isEmpty(values.via_secundaria) && this.$isEmpty(values.via_secundaria_letra) &&
            this.$isEmpty(values.via_secundaria_numero_o_nombre)) {
            this.cancelar()
          } else {
            if (!err) {
              this.$emit('input', this.direccion)
              this.$emit('success', values)
            }
          }
        })
      },
      cancelar () {
        if (this.modalLoading) return
        this.modalLoading = false
        this.$emit('cancel')
      },
      calcularDireccion (chengedValues) {
        let campos = [
          'via_principal',
          'via_principal_numero_o_nombre',
          'via_principal_letra',
          'via_principal_otros',
          'via_principal_punto_cardinal',
          'via_secundaria',
          'via_secundaria_numero_o_nombre',
          'via_secundaria_letra',
          'numero_inmueble',
          'comp1',
          'comp1_num',
          'comp2',
          'comp2_num',
          'comp3',
          'comp3_num'
        ]
        let values = this.form.getFieldsValue()
        this.direccion = ''
        campos.map(campo => {
          if (!JSUtils.isEmpty(values[campo])) {
            this.direccion += ' ' + values[campo]
          }
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/DireccionEstructurada/DireccionEstructurada.vue